import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { debounceTime, takeUntil, tap } from 'rxjs/operators';

import { DestroySubscriptionsService } from '@libs/src/destroy-subscription/destroy-subscription.service';
import { FormService } from '@main-client/src/app/form/form.service';

@Component({
  providers: [DestroySubscriptionsService],
  selector: 'app-form-template-body-select',
  standalone: false,
  templateUrl: './form-template-body-select.component.html',
})
export class FormTemplateBodySelectComponent implements OnInit {
  @Input() inputInformation: any;
  @Input() formGroup: UntypedFormGroup;
  @Output() formChange: EventEmitter<any> = new EventEmitter();
  separatorKeysCodes = [ENTER, COMMA, SPACE];

  constructor(
    private destroy$: DestroySubscriptionsService,
    private formService: FormService,
  ) {}

  ngOnInit(): void {
    if (!this.formGroup) {
      this.formGroup = this.formService.generateFormGroup([
        this.inputInformation,
      ]);
    }
    this.formGroup.valueChanges
      .pipe(
        takeUntil(this.destroy$),
        debounceTime(200),
        tap((formValue) => this.onFormChange(formValue, this.formGroup)),
      )
      .subscribe();
  }

  onFormChange(update: any, formGroup: any) {
    if (!this.formChange) {
      return;
    }
    this.formChange.emit({ update, formGroup });
  }
}
